export const MEMBRANES_ROOT_LINK_ID = "membranes";

export const MEMBRANES_DATE_TIME_LINK_ID = "membranesDateTime";
export const MEMBRANES_DATE_LINK_ID = "membranesDate";
export const MEMBRANES_TIME_LINK_ID = "membranesTime";

export const MEMBRANES_FLUID_COLOR_LINK_ID = "membranesFluidColor";
export const MEMBRANES_FLUID_COLOR_OTHER_LINK_ID = "membranesFluidColorOther";
export const MEMBRANES_POOLING_LINK_ID = "membranesPooling";
export const MEMBRANES_NITRAZINE_LINK_ID = "membranesNitrazine";
export const MEMBRANES_FERN_RESULTS_LINK_ID = "membranesFernResults";
export const MEMBRANES_NOTES_LINK_ID = "membranesNotes";
export const MEMBRANES_SIGNATURE_INITIALS_LINK_ID = "membranesSignatureInitials";

export const MEMBRANES_QUESTIONNAIRE_NAME = "membranes";
